import i18n from '@/i18n';
import S_base from '@/service/api/v1/__base';
import store from "@/store"

export default {
  async index(params) {
    const res = await S_base.index({
      modelName: 'v2/analysis/system_class_total',
      params: params,
    });
    return res;
  },
  async contractorEnterRecordIndex(params) {
    const res = await S_base.index({
      modelName: 'v2/analysis/contractor_enter_record_total',
      params: params,
    });
    return res;
  },
  setNumberCardData(allSystemClass, allFactorySystemClass, systemData, totalData, contractorData, factorySubscription) {
    let resultNumCardData = [];
    const disableText =  "選擇之工廠此服務尚未開通。";
    const disableBtnText=  "升級開通";
    if (!allSystemClass?.length || !systemData?.length || !contractorData?.length) return resultNumCardData;
    const {systemClassDataList, factorySystemClassDataList} = this.setClassDataList(allSystemClass, allFactorySystemClass, systemData);
    resultNumCardData = [
      {
        title: {
          text: '風險事件處理中',
          icon: 'icon-nav-event-filled',
          num: totalData[0] ? totalData[0].event_count : 0,
          tooltips: '處理中的總量',
          value: 'event',
        },
        updated_at:
          systemData && systemData[0] ? systemData[0].updated_at : '',
        bottomText: i18n.t('單一數量可能涉及數個領域'),
        numberInfos: [
          {
            numberTag: '新增',
            toolTips: '24小時內新增且狀態為處理中的數量',
          },
          {
            numberTag: '累計',
            toolTips: '累計至目前狀態為處理中的數量',
          },
        ],
        multiSystemClasses: this.systemTypeDate(
          systemClassDataList,
          factorySystemClassDataList,
          'event_current_count',
          'event_total_count',
          '+',
        ),
        isDisable: !factorySubscription.event,
        disableText,
        disableBtnText,
      },
      {
        title: {
          text: '警示未排除',
          icon: 'icon-nav-alert-filled',
          num: totalData[0] ? totalData[0].alert_count : 0,
          tooltips: '未排除的總量',
          value: 'alert',
        },
        updated_at:
          systemData && systemData[0] ? systemData[0].updated_at : '',
        bottomText: i18n.t('單一數量可能涉及數個領域'),
        numberInfos: [
          {
            numberTag: '新增',
            toolTips: '24小時內新增且狀態為處理中的數量',
          },
          {
            numberTag: '累計',
            toolTips: '累計至目前狀態為處理中的數量',
          },
        ],
        multiSystemClasses: this.systemTypeDate(
          systemClassDataList,
          factorySystemClassDataList,
          'alert_current_count',
          'alert_total_count',
          '+',
        ),
      },
      {
        title: {
          text: '任務處理中',
          icon: 'icon-nav-assignment-filled',
          num: totalData[0] ? totalData[0].task_count : 0,
          tooltips: '處理中的總量',
          value: 'task',
        },
        updated_at:
          systemData && systemData[0] ? systemData[0].updated_at : '',
        bottomText: i18n.t('單一數量可能涉及數個領域'),
        numberInfos: [
          {
            numberTag: '新增',
            toolTips: '24小時內新增且狀態為處理中的數量',
          },
          {
            numberTag: '累計',
            toolTips: '累計至目前狀態為處理中的數量',
          },
        ],
        multiSystemClasses: this.systemTypeDate(
          systemClassDataList,
          factorySystemClassDataList,
          'task_current_count',
          'task_total_count',
          '+',
        ),
      },
      {
        title: {
          text: '證照即將到期',
          icon: 'icon-license-filled',
          num: totalData[0] ? totalData[0].license_count : 0,
          tooltips: '即將到期的總量',
          value: 'license',
        },
        updated_at:
          systemData && systemData[0] ? systemData[0].updated_at : '',
        bottomText: i18n.t('單一數量可能涉及數個領域'),
        numberInfos: [
          {
            numberTag: '已逾期',
            toolTips: '已逾期的數量',
          },
          {
            numberTag: '即將到期',
            toolTips: '三個月內到期的數量',
          },
        ],
        multiSystemClasses: this.systemTypeDate(
          systemClassDataList,
          factorySystemClassDataList,
          'license_expired_count',
          'license_expiring_count',
        ),
        isDisable: !factorySubscription.license,
        disableText,
        disableBtnText,
      },
      {
        title: {
          text: '變動評估中',
          icon: 'icon-nav-change-filled',
          num: totalData[0] ? totalData[0].change_count : 0,
          tooltips: '評估中的總量',
          value: 'change',
        },
        updated_at:
          systemData && systemData[0] ? systemData[0].updated_at : '',
        bottomText: i18n.t('單一數量可能涉及數個領域'),
        numberInfos: [
          {
            numberTag: '執行中',
            toolTips: '執行中的數量',
          },
          {
            numberTag: '評估逾期',
            toolTips: '狀態為評估中且逾期的數量',
          },
        ],
        multiSystemClasses: this.systemTypeDate(
          systemClassDataList,
          factorySystemClassDataList,
          'change_executing_count',
          'change_expired_count',
        ),
        isDisable: !factorySubscription.change,
        disableText,
        disableBtnText,
      },
      {
        title: {
          text: '今日進場',
          icon: 'icon-nav-entry-filled',
          num: totalData[0] ? totalData[0].contractor_enter_record_count : 0,
          tooltips: '今日進場的總量',
          value: 'enter_record',
        },
        numberInfos: [],
        systemType: [],
        bigNumber: [
          {
            title: '今日未復歸',
            tooltips: '今日未復歸的數量',
            number1: contractorData[0]
              ? contractorData[0].non_return_current_count
              : 0,
          },

          {
            title: '昨日未復歸',
            tooltips: '昨日未復歸的數量',
            number2: contractorData[0].non_return_yesterday_count
              ? contractorData[0].non_return_yesterday_count
              : 0,
          },
        ],
        isDisable: !factorySubscription.contractor,
        disableText,
        disableBtnText,
      },
    ];
    return resultNumCardData;
  },
  systemTypeDate(
    systemClassDataList,
    factorySystemClassDataList,
    systemKey,
    totalKey,
    preText = '',
  ) {
    if (!systemClassDataList?.length && !factorySystemClassDataList?.length) return [];
    const multiSystemClasses = [];
    if (factorySystemClassDataList?.length) {
      multiSystemClasses.push({
        title: '自訂領域',
        classList: this.getClassList(factorySystemClassDataList, systemKey, totalKey, preText, 'factory_system_classes'),
      })
    }
    if (systemClassDataList?.length) {
      multiSystemClasses.push({
        title: '預設領域',
        classList: this.getClassList(systemClassDataList, systemKey, totalKey, preText, 'system_classes'),
      })
    }
    return multiSystemClasses;
  },
  userSystemSubclassesAuthCheck(allChecklists){
    const availableSubClassesId = [];
    const currentUser = store.state.stone_auth.currentUser;
    const isAdmin = currentUser.is_administrator;
    if (isAdmin) return allChecklists;
    currentUser.user_factory_system_subclasses.forEach(item=>{
      item.system_subclasses.forEach((subclass) => {
        if (!availableSubClassesId.includes(subclass.id)) {
          availableSubClassesId.push(subclass.id);
        }
      });
    });
    const authClassChecklist = allChecklists.filter((data)=>{
      let isUserHasSubclassesAuth = true;
      data.system_subclasses.forEach((item)=>{
        if (!availableSubClassesId.includes(item.id)) {
          isUserHasSubclassesAuth = false;
        }
      })
      return isUserHasSubclassesAuth;
    });
    return authClassChecklist
  },
  setClassDataList(allSystemClass, allFactorySystemClass, systemData) {
    return systemData.reduce((acc, item) => {
      if (
        item.system_class?.id
      ) {
        const systemClass = allSystemClass.find(systemClass => systemClass.id === item.system_class.id);
        if (!systemClass) return acc;
        acc.systemClassDataList.push({...item, classTitle: this.getClassTitle(systemClass), class: systemClass });
      } else if (
        item.factory_system_class?.id
      ) {
        const factorySystemClass = allFactorySystemClass.find(systemClass => systemClass.id === item.factory_system_class.id);
        if (!factorySystemClass) return acc;
        acc.factorySystemClassDataList.push({...item, classTitle: this.getClassTitle(factorySystemClass), class: factorySystemClass });
      }
      return acc;
    },{
      systemClassDataList: [],
      factorySystemClassDataList: [],
    });
  },
  getClassTitle(systemClass) {
    return systemClass?.locales?.[i18n.locale]?.name || systemClass?.name;
  },
  getClassList(classDataList, systemKey, totalKey, preText = '', apiParamKey = 'system_classes') {
    return classDataList.map(systemClass => ({
      id: systemClass.class?.id,
      image: systemClass.class?.icon,
      systemTitle: systemClass.classTitle,
      number1: systemClass[systemKey]
        ? preText + systemClass[systemKey]
        : 0,
      number2: systemClass[totalKey]
        ? systemClass[totalKey]
        : 0,
      apiParamKey,
    }))
  },
};
